import {Injectable} from "@angular/core";
import {Observable, ReplaySubject, share, Subject} from "rxjs";

@Injectable()
export class FUIChromeControlsService {
    private _activeControl: Subject<number> = new Subject<number>();
    public activeControl$: Observable<number> = this._activeControl.asObservable().pipe(share({
        connector: () => new ReplaySubject(1),
        resetOnError: false,
        resetOnComplete: false,
        resetOnRefCountZero: false
    }));

    private _ids: number[] = new Array<number>();

    constructor() {

    }

    /**
     * Simple ID generator, nothing too overcooked
     * as the ID is not a particularly important one
     * and is only used for differentiation of presentational
     * states (hover, active etc)
     * @returns {Promise<number>}
     */
    generateId(): Promise<number> {
        return new Promise<number>((resolve, reject) => {
            let id = Math.random();

            if (this._ids.indexOf(id) == -1) {
                this._ids.push(id);

                return resolve(id);
            }
            else {
                let adjustedId = id + Math.random();

                this._ids.push(adjustedId);

                return resolve(adjustedId);
            }
        })
    }

    resetActiveControl(): void {
        this._activeControl.next(null);
    }

    /**
     *
     * @param id
     */
    setActiveControl(id: number): void {
        if (this._ids.indexOf(id) > -1) {
            this._activeControl.next(id);
        }
        else {
            this._activeControl.next(null);
        }
    }
}
